import {
  NgModule,
  Inject,
} from '@angular/core';
import { FEATURE_COMPONENTS } from './tokens';
import { ComponentRootModule } from './component-root.module';

@NgModule()
export class ComponentFeatureModule {

  constructor(
    root: ComponentRootModule,
    @Inject(FEATURE_COMPONENTS) featureComponents: any[][]
  ) {
    featureComponents.forEach(groups => groups.forEach(rc => root.add(rc)));
  }

}
